"use client";

import React, { useMemo, useState } from "react";
import { cn } from "utils";
import { Icon } from "@ospweb/sdk-ui";
import log from "logbeacon";
import { useParams } from "next/navigation";
import { useSnapshot } from "valtio";
import { PortfolioContainer } from "../PortfolioContainer";
import { getAllPortfolioOption } from "../PortfolioContainer/constants";
import type { PortfolioItem } from "../PortfolioContainer/types";
import Translations from "@translate/components/PortfolioSwitch/PortfolioSwitch";
import { I18nUtil } from "@utils/i18n";
import { ROUTER_PATH } from "@/src/config";
import { favoritesCenter } from "@/src/store/favorite/FavoritesCenter";
import { useShellRouter } from "@/src/hooks";
const I18n = I18nUtil.createScoped(Translations);
const ReachMaxTag = () => {
  return (
    <div
      className={cn(
        "bg-background_white_overlay5 px-[6px] md:py-[2px] py-0 rounded-1 shrink-0",
      )}
    >
      <span className="body_bold_s text-content_secondary">
        {I18n.t("Reach Max.")}
      </span>
    </div>
  );
};

export const PortfolioSwitch: React.FC = () => {
  const { portfolioId: currentPortfolioId, tab } = useParams();
  const router = useShellRouter();
  // 管理 popover 开关状态
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  // 获取收藏夹数据
  const { userFolders } = useSnapshot(favoritesCenter.state);

  const ALL_PORTFOLIO_OPTION = getAllPortfolioOption();

  // 是否为 All
  const isAllSelected = currentPortfolioId === ALL_PORTFOLIO_OPTION.id;

  // 当前选中的收藏夹信息与展示文案
  const currentFolder = useMemo(
    () => userFolders?.find((f) => f.id === currentPortfolioId),
    [userFolders, currentPortfolioId],
  );
  const currentLabel = useMemo(
    () =>
      isAllSelected
        ? ALL_PORTFOLIO_OPTION.label
        : (currentFolder?.name ?? I18n.t("Select Portfolio")),
    [isAllSelected, currentFolder?.name],
  );

  // 是否达到最大收藏量（仅非 All 选项）
  const showReachMax = useMemo(
    () => !isAllSelected && (currentFolder?.asset_count ?? 0) >= 30,
    [isAllSelected, currentFolder?.asset_count],
  );

  // 处理 portfolio 点击事件
  const handleItemClick = (item: PortfolioItem) => {
    router.replace(`${ROUTER_PATH.PORTFOLIO}/${tab}/${item.id}`);
    setIsPopoverOpen(false);
    log.debug("[文案]Portfolio switched to:", item.id);
  };

  // // 处理创建 portfolio
  // const handleCreatePortfolio = () => {
  //   log.debug("[文案]Create new portfolio clicked");
  //   // 这里可以添加创建逻辑
  // };

  // 为 data 添加 isActive 标记
  // const enrichedData = portfolios.map((item) => ({
  //   ...item,
  //   isActive: item.id === currentPortfolioId,
  // }));

  return (
    <PortfolioContainer
      mode="select"
      onItemClick={handleItemClick}
      popoverPlacement="bottom-start"
      onPopoverStateChange={setIsPopoverOpen}
    >
      <div className={cn("flex w-full min-w-0")}>
        <div className="flex gap-1 items-center justify-start w-full min-w-0">
          <div className="md:headline_regular_s title_l text-content_primary truncate min-w-0 flex-1 md:flex-none">
            {currentLabel}
          </div>
          {showReachMax && <ReachMaxTag />}
          <Icon
            name={isPopoverOpen ? "chevron-up" : "chevron-down"}
            size={24}
            className="text-content_primary transition-transform duration-200"
          />
        </div>
      </div>
    </PortfolioContainer>
  );
};
